import type { PartnerConfig } from "@/content/partners/types"

export const SINSERVES_PARTNER_SLUG = "sinserves"

export const SINSERVES_LOGO_PATH = "/partners/sinserves/logo.jpg"

export const sinservesBrand = {
  accent: "#22c55e",
  accentDark: "#15803d",
  accentLight: "#86efac",
  ringFrom: "#4ade80",
  ringTo: "#166534",
} as const

export const sinservesPartnerConfig: PartnerConfig = {
  slug: SINSERVES_PARTNER_SLUG,
  name: "SINSERVES",
  fullName: "Sindicato dos Servidores Públicos Municipais de Esmeraldas-MG",
  logoPath: SINSERVES_LOGO_PATH,
  benefitMode: "next_band",
  isActive: true,
  metadata: {
    city: "Esmeraldas",
    state: "MG",
  },
}

export const sinservesPartnerContent = {
  ...sinservesPartnerConfig,
  tagline: "Representação dos servidores públicos municipais de Esmeraldas",
  websiteUrl: null as string | null,
  benefitHeadline: "Benefício para filiados",
  heroHeadline: "Filiados do SINSERVES têm desconto extra na energia",
  heroSubtitle: "Energia solar por assinatura, sem obra e sem investimento inicial.",
  partnershipIntro:
    "O SINSERVES representa os servidores públicos municipais de Esmeraldas. Filiados têm desconto extra na energia por assinatura — basta se cadastrar e o benefício vale automaticamente.",
  partnershipTitle: "SINSERVES e energia limpa, juntos",
} as const
